import React, { useState, useEffect } from "react";
import { FileUploadIcon, PDFIcon, XLSXIcon, DOCXIcon } from "../../../icons";
import { Form } from "react-final-form";
import { P_Props } from "./DocumentationForm.type";
import { SimpleModalHeader, Notification, Pulse } from "../../../components";
import { loadCallback } from "../../../../utils";
import { FormControlLabel, Switch } from "@material-ui/core";
import { PriorityHigh as PriorityHighIcon } from "@material-ui/icons";
import { DocumentStatus } from "../../../../models";
import { FileType } from "../../../../constants"

const DocumentationFormPresenter: React.FC<P_Props> = (props) => {
  let submit: any;
  const [visibleWarningModal, setVisibleWarningModal] = useState<boolean>(false);

  useEffect(() => {
    setVisibleWarningModal(props.isDupplicate)
  }, [props.isDupplicate])

  const toggleWarningModal = () => {
    setVisibleWarningModal(!visibleWarningModal);
  };

  return (
    <>
      <Form
        initialValues={{
          status: DocumentStatus.PUBLISH
        }}
        initialValuesEqual={() => true}
        onSubmit={async (values, form) => {
          await props.handleSubmit(values);
        }}
        render={({ handleSubmit, form, pristine }) => {
          submit = handleSubmit;

          return (
            <div className="file-upload">
              <SimpleModalHeader
                title="Upload File"
                onClose={props.onCancel}
              />
              <form onSubmit={handleSubmit}>
                <div className="file-upload--header">
                  <h3 className="file-upload--switch__label">Status</h3>
                  <FormControlLabel
                    control={
                      <Switch
                        checked={props.publish}
                        // onChange={(e) => { }}
                        className="app-switch-box"
                        onClick={(e) => {
                          e.preventDefault();
                          props.handleStatusChange();
                        }}
                      />
                    }
                    label={<div className="file-upload--switch__label">{props.publish ? "Publish" : "Not Publish"}</div>}
                  />
                </div>
                <div className="file-upload__body">
                  {props.fileUpload
                    ? (
                      <div className="file-upload__body__uploaded">
                        <div className="file-upload__body__uploaded__img">
                          {props.fileType === FileType.PDF
                            ? <PDFIcon size={[37, 49]} color="#E93C3C" />
                            : (props.fileType === FileType.DOC || props.fileType === FileType.DOCX)
                              ? <DOCXIcon size={[37, 49]} color="#439BCF" />
                              : (props.fileType === FileType.XLSX || props.fileType === FileType.XLS)
                                ? <XLSXIcon size={[37, 49]} color="#4EAA39" />
                                : ""
                          }
                        </div>
                        <div className="file-upload__body__uploaded__input">
                          {props.fileUpload.name}
                        </div>
                      </div>
                    )
                    : (
                      <div className="file-upload__body__no-file">
                        <div className="file-upload__body__no-file__input">
                          <label>
                            <FileUploadIcon size={[30, 30]} color="#6658F3" />
                            <p>Upload file</p>
                          </label>
                          <input accept=".doc,.docx,.xls,.xlsx,.pdf" type="file" onChange={(e) => props.handleFileUpload(e)} />
                        </div>
                      </div>
                    )}
                </div>
                <div className="file-upload--footer">
                  <div className="file-upload--footer__text">
                    <b>Complete the upload</b><br />
                    or change other files
                  </div>
                  <div className="file-upload__actions">
                    <button
                      disabled={Boolean(props.originFileObj)}
                      className="file-upload__actions__save"
                      onClick={(e) => {
                        loadCallback(submit, e);
                      }}
                    >
                      Save
                    </button>
                  </div>
                </div>
              </form>
            </div>
          );
        }}
      />
      <Notification
        visible={visibleWarningModal}
        title="Delete file"
        subTitle={`An file name “${props.fileUpload?.name}” already exists. Do you want to replace it with the one you’re uploading?`}
        icon={
          <Pulse color={"yellow"}>
            <div className="notification-icon-box yellow">
              <PriorityHighIcon style={{ fontSize: "5rem", color: "#fff" }} />
            </div>
          </Pulse>
        }
        actions={
          <>
            <button
              className="blog-listing__delete-modal__actions__cancel"
              onClick={() => {
                toggleWarningModal();
              }}
            >
              Replace
            </button>
            <button
              className="blog-listing__delete-modal__actions__confirm"
              onClick={() => {
                toggleWarningModal();
                props.removeFileUpload();
              }}
            >
              Upload another file
            </button>
          </>
        }
      />
    </>
  );
};

export default DocumentationFormPresenter;
